import React from "react"
import useSearchParamStore from "../../../stores/SearchParamStore"
import DefaultButton from "../../../components/DefaultButton"
import useStyles from "../../styles"
import { Plus } from "lucide-react"
import { SearchHeader } from "../../../components/SearchHeader"

const CampaignsLayout = () => {
  const { searchParam, setSearchParam, setOpenModal } = useSearchParamStore()
  const classes = useStyles()

  const handleOpenTagModal = () => {
    setOpenModal(true)
  }

  return (
    <div className={classes.buttonContainer}>
      <DefaultButton stylization="primary" startIcon={<Plus />} onClick={handleOpenTagModal}>
        Novo
      </DefaultButton>
      <SearchHeader searchParam={searchParam} setSearchParam={setSearchParam} placeholder={"Pesquisar..."} />
    </div>
  )
}
export default CampaignsLayout
